import { useContext } from "react";

import { EditMeetingContext } from "./EditMeetingContext";

export function useEditMeeting() {
  const context = useContext(EditMeetingContext);
  if (!context) {
    throw new Error("useEditMeeting must be used within a EditMeetingProvider");
  }
  return context;
}
